import { render, staticRenderFns } from "./PhoneModal.vue?vue&type=template&id=3d8c45e0&scoped=true"
import script from "./PhoneModal.vue?vue&type=script&lang=js"
export * from "./PhoneModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneModal.vue?vue&type=style&index=0&id=3d8c45e0&prod&scoped=true&lang=less"
import style1 from "./PhoneModal.vue?vue&type=style&index=1&id=3d8c45e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c45e0",
  null
  
)

export default component.exports